import Vue from 'vue';
import VueRouter from 'vue-router';
import Map from '@/views/Map.vue';
import Forbidden from '@/views/Forbidden.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Forbidden',
    component: Forbidden
  },
  {
    path: '/map/:id/:token?/:token2?',
    name: 'map',
    component: Map
  }
];

const router = new VueRouter({
  routes
});

export default router;
